var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-financial-calendar" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.calendar, function (item, index) {
        return _c(
          "div",
          { key: index },
          [_c("CalendarItem", { attrs: { calendarItem: item } })],
          1
        )
      }),
      _vm._v(" "),
      _vm.seeAllUrl
        ? _c("div", { staticClass: "c-financial-calendar-link" }, [
            _c("a", { attrs: { href: _vm.seeAllUrl } }, [
              _vm._v(_vm._s(_vm.seeAllLabel)),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-financial-calendar-headers" }, [
      _c("div", [_vm._v("Date")]),
      _vm._v(" "),
      _c("div", [_vm._v("Headline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }